import { ChatroomData } from "./utilities";

interface ChatsProps {
  recentChatrooms: ChatroomData[];
  pendingChatrooms: ChatroomData[];
  selectedId: string | null;
  onSelect: (chatroom: ChatroomData) => void;
}

function formatLastUpdate(dateStr: string | null): string {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 60) return `${diffMin}m`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h`;
  return d.toLocaleDateString();
}

function ChatItem({ room, selectedId, onSelect, isPending }: {
  room: ChatroomData;
  selectedId: string | null;
  onSelect: (room: ChatroomData) => void;
  isPending: boolean;
}) {
  return (
    <button
      className={`fadfaddah-chats-item ${selectedId === room.id ? "fadfaddah-chats-item--active" : ""} ${isPending ? "fadfaddah-chats-item--pending" : ""}`}
      onClick={() => onSelect(room)}
    >
      <div className="fadfaddah-chats-avatar">
        {room.patient?.profile_img ? (
          <img src={room.patient.profile_img} alt="" />
        ) : (
          <span>{room.patient?.name?.charAt(0) || "?"}</span>
        )}
      </div>
      <div className="fadfaddah-chats-info">
        <div className="fadfaddah-chats-name">
          {room.patient?.name || "Unknown Patient"}
          {isPending && <span className="fadfaddah-chats-pending-badge">Pending</span>}
        </div>
        <div className="fadfaddah-chats-preview">
          {room.lastMessage || "No messages yet"}
        </div>
      </div>
      <div className="fadfaddah-chats-side">
        <span className="fadfaddah-chats-time">
          {formatLastUpdate(room.lastUpdate)}
        </span>
        {!isPending && room.unseenCount > 0 && (
          <span className="fadfaddah-chats-badge">{room.unseenCount}</span>
        )}
      </div>
    </button>
  );
}

export function Chats({ recentChatrooms, pendingChatrooms, selectedId, onSelect }: ChatsProps) {
  const hasAny = recentChatrooms.length > 0 || pendingChatrooms.length > 0;

  if (!hasAny) {
    return (
      <div className="fadfaddah-chats-empty">
        No active fadfaddah conversations
      </div>
    );
  }

  return (
    <div className="fadfaddah-chats-list">
      {pendingChatrooms.length > 0 && (
        <>
          <div className="fadfaddah-chats-section-header">
            Pending Replies ({pendingChatrooms.length})
          </div>
          {pendingChatrooms.map((room) => (
            <ChatItem
              key={room.id}
              room={room}
              selectedId={selectedId}
              onSelect={onSelect}
              isPending
            />
          ))}
        </>
      )}

      {recentChatrooms.length > 0 && (
        <>
          <div className="fadfaddah-chats-section-header">
            Recent Chats ({recentChatrooms.length})
          </div>
          {recentChatrooms.map((room) => (
            <ChatItem
              key={room.id}
              room={room}
              selectedId={selectedId}
              onSelect={onSelect}
              isPending={false}
            />
          ))}
        </>
      )}
    </div>
  );
}
